import { cloneElement, isValidElement, type ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/modern/utils";
import type { EntityFinderConfigIcon } from "@/modern/components/entity-finder/types";

function isLucideIconComponent(icon: EntityFinderConfigIcon): icon is LucideIcon {
  if (typeof icon === "function") return true;

  return (
    typeof icon === "object" &&
    icon !== null &&
    "render" in icon &&
    typeof (icon as { render?: unknown }).render === "function"
  );
}

export function renderEntityFinderConfigIcon(
  icon: EntityFinderConfigIcon,
  size: number,
  className?: string
): ReactNode {
  if (isLucideIconComponent(icon)) {
    const Icon = icon as LucideIcon;
    return <Icon size={size} className={className} aria-hidden />;
  }

  if (isValidElement(icon)) {
    const existingClassName =
      typeof icon.props === "object" && icon.props !== null && "className" in icon.props
        ? String((icon.props as { className?: string }).className ?? "")
        : "";

    return cloneElement(icon, {
      className: cn(existingClassName, className),
      "aria-hidden": true,
    } as Record<string, unknown>);
  }

  return null;
}
